import { SafeBaseObject } from "@app/core/models/base-object.models"

export interface IResApiGetHeritageDepositParams {
    PriceTypeID?: number;
    Currency?: string;
}

export class ResHeritageTier extends SafeBaseObject {
    priceTypeID = 0;
    priceTypeName = '';

    constructor(data?: any) {
        super();
        this.updateData(data);
    }
}

export class ResHeritageCurrency extends SafeBaseObject {
    currency = '';

    constructor(data?: any) {
        super();
        this.updateData(data);
    }
}

export class ResHeritagePrice extends SafeBaseObject {
    priceTypeID = 0;
    priceTypeName = '';
    amount = 0;
    currency = '';

    constructor(data?: any) {
        super();
        this.updateData(data);
    }
}